import React from 'react';

const ComputerChatScreenIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="222" height="143" fill="none">
      <path
        d="m200.04 106.19 2.37 1.389c.452.264 1.012.27 1.464.006l11.038-6.336a.687.687 0 0 0 .012-1.182l-5.449-3.268-9.429 9.391M101.837 132.456l3.353 1.905a8.81 8.81 0 0 0 8.709 0l58.937-33.603c3.036-1.735 3.036-6.07 0-7.8l-86.45-49.22a9.62 9.62 0 0 0-9.657.092L12.943 81.762l88.894 50.694Z"
        fill="#101841"
      />
      <path
        d="M168.65 94.222v2.489a4.024 4.024 0 0 1-2.024 3.658l-55.421 32.026a9.108 9.108 0 0 1-4.733 1.219c-.327 0-.666-.025-.993-.063a9.36 9.36 0 0 1-3.438-1.156L32.364 92.248l-5.003-2.62L1.76 87.596a.819.819 0 0 1-.73-1.031v-2.854l3.432.604L73.51 44.659a8.521 8.521 0 0 1 8.486.007l84.617 48.682c.39.22.717.503 1 .811l1.031.057.006.006Z"
        fill="#0085FF"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.782 128.944v4.494a9.42 9.42 0 0 1-2.735-1.037L32.371 92.254l-5.003-2.62-25.602-2.031a.819.819 0 0 1-.729-1.03v-2.854l3.432.603 17.644-10.133 82.669 54.761v-.006ZM106.472 129.34v4.274c-.326 0-.666-.025-.993-.063v-4.211h.993Z"
        fill="#0070D4"
      />
      <path
        d="M168.65 94.222v2.489a4.024 4.024 0 0 1-2.024 3.658l-55.421 32.026a9.108 9.108 0 0 1-4.733 1.219c-.327 0-.666-.025-.993-.063a9.36 9.36 0 0 1-3.438-1.156L32.364 92.248l-5.003-2.62L1.76 87.596a.819.819 0 0 1-.73-1.031v-2.854l3.432.604L73.51 44.659a8.521 8.521 0 0 1 8.486.007l84.617 48.682c.39.22.717.503 1 .811l1.031.057.006.006Z"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m42.83 120.67-16.946-9.68c-2.163-1.232-2.163-4.33 0-5.569a7.172 7.172 0 0 1 7.109 0l16.92 9.693c2.194 1.257 2.15 4.419-.081 5.613l-.075.038a7.153 7.153 0 0 1-6.915-.095h-.012Z"
        fill="#101841"
      />
      <path
        d="M30.026 110.292c2.24 0 4.054-1.041 4.054-2.326 0-1.284-1.815-2.325-4.054-2.325-2.239 0-4.054 1.041-4.054 2.325 0 1.285 1.815 2.326 4.054 2.326Z"
        fill="#fff"
      />
      <path
        d="M112.538 47.197v6.789c0 .685-.364 1.314-.961 1.66l-4.997 2.878 2.055 1.477 4.255-2.583a3.597 3.597 0 0 0 1.735-3.068v-7.24l-2.087.087ZM127.56 31.259l-.038-1.703-.038-1.434-.238-9.56 4.205-2.326 2.413 1.408a3.433 3.433 0 0 1 1.716 2.967l-.176 2.98-.088 1.477-.106 1.728-1.597 26.752a2.02 2.02 0 0 1-1.194 1.842l-4.205 1.898-.648-26.023"
        fill="#12173D"
      />
      <path
        d="m127.56 31.259-.038-1.703-.038-1.434-.238-9.56 4.205-2.326 2.413 1.408a3.433 3.433 0 0 1 1.716 2.967l-.176 2.98-.088 1.477-.106 1.728-1.597 26.752a2.02 2.02 0 0 1-1.194 1.842l-4.205 1.898-.648-26.023"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m135.581 20.608-.176 2.98-7.92 4.531-.239-9.56-3.884-2.238 4.048-2.401 4.041 2.313 2.414 1.408a3.435 3.435 0 0 1 1.716 2.967ZM135.316 25.066l-.107 1.723-7.649 4.469-.038-1.704 7.794-4.488Z"
        fill="#0085FF"
      />
      <path
        d="M134.343 39.827c.091-1.1-.539-2.05-1.408-2.122-.868-.072-1.646.761-1.737 1.862-.091 1.1.539 2.05 1.408 2.122.868.072 1.646-.762 1.737-1.862Z"
        fill="#101841"
      />
      <path
        d="m131.451 16.236 2.414 1.408a3.435 3.435 0 0 1 1.716 2.967l-.176 2.98-.088 1.477-.107 1.728-1.597 26.752a2.02 2.02 0 0 1-1.194 1.842l-4.205 1.898-.648-26.023"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m102.481 129.298-1.861-1.075"
        stroke="#1C1C1C"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m102.481 129.298-1.861-1.075"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m1.414 82.751 72.102-41.397a8.52 8.52 0 0 1 8.486 0l84.611 48.683c2.716 1.558 2.716 5.45.007 7.014l-55.415 32.026a9.164 9.164 0 0 1-9.164 0L27.895 86.359l-26.13-2.074c-.81-.063-1.055-1.131-.351-1.534Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M103.059 110.318a7.287 7.287 0 0 0 7.229-.025l20.032-11.578c2.313-1.339 2.307-4.658-.019-5.984a6.11 6.11 0 0 0-6.059.013l-21.202 12.2c-2.08 1.201-2.074 4.186.019 5.374Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m128.629 97.125-19.768 11.477a3.92 3.92 0 0 1-3.942-.012 1.52 1.52 0 0 1-.748-1.1 1.548 1.548 0 0 1 .346-1.238c.113-.132.252-.252.415-.34l20.152-11.647a3.478 3.478 0 0 1 1.76-.478c.603 0 1.238.163 1.785.49a1.646 1.646 0 0 1-.006 2.841l.006.007Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m127.875 97.513-19.348 11.257a3.918 3.918 0 0 1-3.608-.182 1.518 1.518 0 0 1-.748-1.1 1.548 1.548 0 0 1 .346-1.238l19.926-11.528a2.677 2.677 0 0 1 1.351-.365c.622 0 1.238.214 1.735.635.786.66.867 1.76.339 2.527l.007-.006Z"
        fill="#0088FE"
      />
      <path
        d="M129.352 95.145c-1.427-1.106-2.867-.522-2.867-.522s-19.196 10.943-22.307 12.867a1.532 1.532 0 0 1 .76-1.578l20.152-11.647a3.481 3.481 0 0 1 3.545.012c.352.208.591.522.717.861v.007Z"
        fill="#12173D"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M115.492 117.396a7.285 7.285 0 0 0 7.228-.025l20.032-11.578c2.314-1.339 2.307-4.658-.018-5.984a6.113 6.113 0 0 0-6.06.013l-21.201 12.2c-2.081 1.201-2.075 4.186.019 5.374Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m141.062 104.203-14.614 8.486-5.154 2.992a3.899 3.899 0 0 1-3.935-.013 1.515 1.515 0 0 1-.748-1.1 1.54 1.54 0 0 1 .327-1.207c.113-.144.257-.27.433-.371l20.152-11.647a3.477 3.477 0 0 1 3.545.013c.352.207.591.521.717.861a1.648 1.648 0 0 1-.723 1.98v.006Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m126.448 112.691-5.154 2.992a3.899 3.899 0 0 1-3.935-.013 1.515 1.515 0 0 1-.748-1.1 1.54 1.54 0 0 1 .327-1.207l6.084-3.463a2.682 2.682 0 0 1 3.087.27c.785.66.867 1.76.339 2.527v-.006Z"
        fill="#0088FE"
      />
      <path
        d="M141.785 102.223c-1.427-1.106-2.866-.522-2.866-.522s-19.197 10.944-22.308 12.867a1.533 1.533 0 0 1 .761-1.578l20.151-11.647a3.477 3.477 0 0 1 1.76-.478c.604 0 1.239.164 1.786.491.351.207.59.521.716.861v.006Z"
        fill="#12173D"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m141.062 104.203-14.614 8.486-5.154 2.992a3.899 3.899 0 0 1-3.935-.013 1.515 1.515 0 0 1-.748-1.1 1.54 1.54 0 0 1 .327-1.207c.113-.144.257-.27.433-.371l20.152-11.647a3.477 3.477 0 0 1 3.545.013c.352.207.591.521.717.861a1.648 1.648 0 0 1-.723 1.98v.006Z"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m128.629 97.125-19.768 11.477a3.92 3.92 0 0 1-3.942-.012 1.52 1.52 0 0 1-.748-1.1 1.548 1.548 0 0 1 .346-1.238c.113-.132.252-.252.415-.34l20.152-11.647a3.478 3.478 0 0 1 1.76-.478c.603 0 1.238.163 1.785.49a1.646 1.646 0 0 1-.006 2.841l.006.007Z"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.027 93.47v3.13c0 .22.145.44.44.603.585.333 1.528.333 2.112 0 .289-.164.434-.384.44-.597v-3.143h-2.992v.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M129.421 88.165v6.084c0 .421-.29.836-.849 1.157-.465.264-1.056.427-1.666.471-.081 0-.169.013-.251.013-.233 0-.459 0-.691-.032-.547-.063-1.069-.214-1.49-.452-.566-.327-.849-.748-.849-1.176v-6.072h5.796v.007Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M129.421 88.165v6.084c0 .421-.289.836-.849 1.157-.465.264-1.056.427-1.666.471v-7.719h2.515v.007ZM126.428 88.166v7.731c-.232 0-.459 0-.691-.031v-7.7h.691Z"
        fill="#0085FF"
      />
      <path
        d="M129.421 88.165v6.084c0 .421-.29.836-.849 1.157-.465.264-1.056.427-1.666.471-.081 0-.169.013-.251.013-.233 0-.459 0-.691-.032-.547-.063-1.069-.214-1.49-.452-.566-.327-.849-.748-.849-1.176v-6.072h5.796v.007Z"
        stroke="#101841"
        strokeWidth=".32"
        strokeMiterlimit="10"
      />
      <path
        d="M126.523 89.817c1.6 0 2.898-.743 2.898-1.66 0-.916-1.298-1.659-2.898-1.659s-2.898.743-2.898 1.66c0 .916 1.298 1.659 2.898 1.659Z"
        fill="#101841"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M123.695 108.467v3.13c0 .22.144.44.44.604.584.333 1.527.333 2.112 0 .289-.164.434-.384.44-.597v-3.143h-2.992v.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M128.088 103.163v6.084c0 .421-.289.836-.848 1.157-.465.264-1.056.427-1.666.471-.082 0-.17.013-.251.013-.233 0-.459 0-.692-.032-.547-.063-1.068-.214-1.489-.452-.566-.327-.849-.748-.849-1.176v-6.072h5.795v.007Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".32"
        strokeMiterlimit="10"
      />
      <path
        d="M128.088 103.163v6.084c0 .421-.289.836-.848 1.157-.465.264-1.056.427-1.666.471v-7.719h2.514v.007ZM125.109 103.162v7.731c-.233 0-.459 0-.692-.031v-7.7h.692Z"
        fill="#0085FF"
      />
      <path
        d="M128.088 103.163v6.084c0 .421-.289.836-.848 1.157-.465.264-1.056.427-1.666.471-.082 0-.17.013-.251.013-.233 0-.459 0-.692-.032-.547-.063-1.068-.214-1.489-.452-.566-.327-.849-.748-.849-1.176v-6.072h5.795v.007Z"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M125.191 104.821c1.6 0 2.897-.743 2.897-1.66 0-.916-1.297-1.659-2.897-1.659-1.601 0-2.898.743-2.898 1.659 0 .917 1.297 1.66 2.898 1.66Z"
        fill="#101841"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M92.952 68.377 59.336 87.46a1.409 1.409 0 0 0-.012 2.452l25.262 14.526c.949.547 2.118.547 3.067 0l33.76-19.379a1.207 1.207 0 0 0 0-2.1L95.994 68.39a3.076 3.076 0 0 0-3.036-.012h-.006Z"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M92.75 73.113a1.694 1.694 0 0 0-.019 2.954l16.161 9.234a3.734 3.734 0 0 0 3.828-.063c.955-.59.93-1.98-.044-2.54l-16.82-9.566a3.16 3.16 0 0 0-3.106-.019ZM84.397 77.766a1.694 1.694 0 0 0-.02 2.954l16.293 9.284a3.734 3.734 0 0 0 3.828-.063c.956-.59.931-1.98-.044-2.54l-16.946-9.617a3.16 3.16 0 0 0-3.105-.018h-.006Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M87.18 66.928 64.007 80.266a5.52 5.52 0 0 1-5.507 0L39.24 69.153a1.875 1.875 0 0 1 0-3.256l24.087-13.784a4.378 4.378 0 0 1 4.387.019l19.473 11.352c1.333.773 1.326 2.69-.013 3.457l.007-.013Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m97.15 94.183-9.861 5.676a2.366 2.366 0 0 1-2.345 0L66.64 89.449a.802.802 0 0 1 0-1.388l10.246-5.865a1.869 1.869 0 0 1 1.867.006l18.391 10.51a.85.85 0 0 1 0 1.47h.007Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M75.139 60.78v2.376h-.007c-.05.95-.71 1.88-1.967 2.602-2.628 1.503-6.89 1.503-9.51 0-1.289-.741-1.949-1.703-1.968-2.677V60.68l1.39.012 10.78.082 1.282.012v-.006Z"
        fill="#0085FF"
      />
      <path
        d="M68.406 64.667c3.714 0 6.725-1.725 6.725-3.853s-3.01-3.853-6.725-3.853-6.726 1.725-6.726 3.853 3.011 3.853 6.726 3.853Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m44.803 66.754.063-1.822 15.62 7.561 3.206-3.25c.584-.006.999-.012.999-.012v3.331s0 .05-.013.082c-.207 1.383-1.143 2.734-2.803 3.853-.39.264-.899.29-1.307.05l-15.356-9.07a.817.817 0 0 1-.403-.729l-.006.006Z"
        fill="#0085FF"
      />
      <path
        d="M151.679 85.396a2.648 2.648 0 0 0-1.313-1.792l-33.792-19.36a6.844 6.844 0 0 0-3.407-.905c-1.182 0-2.294.29-3.325.861a3.156 3.156 0 0 0-1.641 2.527c-.232-1.27.302-2.665 1.603-3.382a6.865 6.865 0 0 1 3.325-.86 6.95 6.95 0 0 1 3.407.904l33.786 19.36a2.686 2.686 0 0 1 1.351 2.653l.006-.006Z"
        fill="#12173D"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M151.679 85.398a2.7 2.7 0 0 1-1.339 2.05l-.346.2a7.678 7.678 0 0 1-7.675.013l-32.553-18.737a3.18 3.18 0 0 1-1.559-2.194c.088-1 .635-1.968 1.641-2.527a6.862 6.862 0 0 1 3.325-.861 6.95 6.95 0 0 1 3.407.905l33.791 19.36a2.703 2.703 0 0 1 1.314 1.791h-.006Z"
        fill="#E5E7EA"
        stroke="#101841"
        strokeWidth=".32"
        strokeMiterlimit="10"
      />
      <path
        d="M151.679 85.398a2.7 2.7 0 0 1-1.339 2.05l-.346.2a7.678 7.678 0 0 1-7.675.013l-32.553-18.737a3.18 3.18 0 0 1-1.559-2.194c.088-1 .635-1.968 1.641-2.527a6.862 6.862 0 0 1 3.325-.861 6.95 6.95 0 0 1 3.407.905l33.791 19.36a2.703 2.703 0 0 1 1.314 1.791h-.006Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="m60.543 74.127-15.387-8.819a.611.611 0 0 1 .044-1.087c4.72-2.15 11.615-1.974 15.978.528 4.362 2.501 4.683 6.625.666 9.334a1.23 1.23 0 0 1-1.301.05v-.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m127.246 18.56-3.884-2.237L101.23 3.588l-1.86-.302 3.262-1.898a2.856 2.856 0 0 1 2.853-.012l21.918 12.546 4.042 2.313"
        fill="#0085FF"
      />
      <path
        d="m127.246 18.56-3.884-2.237L101.23 3.588l-1.86-.302 3.262-1.898a2.856 2.856 0 0 1 2.853-.012l21.918 12.546 4.042 2.313"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m117.428 71.065-4.08-2.351a1.547 1.547 0 0 1 0-2.684 3.546 3.546 0 0 1 3.533 0l4.098 2.35a1.542 1.542 0 0 1 0 2.685 3.592 3.592 0 0 1-3.558 0h.007Z"
        fill="#101841"
      />
      <path
        d="M115.303 68.457c1.097 0 1.986-.51 1.986-1.138 0-.628-.889-1.137-1.986-1.137s-1.986.509-1.986 1.137c0 .629.889 1.138 1.986 1.138Z"
        fill="#fff"
      />
      <path
        d="m183.742 101.583-33.534 19.046a1.417 1.417 0 0 0 0 2.464l33.345 18.932a3.067 3.067 0 0 0 3.049 0l33.729-19.127a1.318 1.318 0 0 0 0-2.294l-33.541-19.021a3.07 3.07 0 0 0-3.048 0Z"
        stroke="#101841"
        strokeOpacity=".4"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m184.038 103.623-30.36 17.235a1.151 1.151 0 0 0 0 2.005l30.184 17.122c.766.44 1.709.44 2.476 0l30.517-17.304a1.075 1.075 0 0 0 0-1.867l-30.341-17.191a2.487 2.487 0 0 0-2.476 0Z"
        fill="#fff"
        stroke="#101841"
        strokeOpacity=".4"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m184.32 105.44-10.409 5.934a.869.869 0 0 0 0 1.509l13.627 7.844a1.87 1.87 0 0 0 1.867 0l10.529-5.99a.804.804 0 0 0 0-1.402l-13.747-7.895a1.904 1.904 0 0 0-1.867 0Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeOpacity=".4"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.805 112.105c1.26 0 2.281-.585 2.281-1.307s-1.021-1.308-2.281-1.308c-1.26 0-2.282.586-2.282 1.308 0 .722 1.022 1.307 2.282 1.307ZM189.405 115.996c1.385 0 2.508-.644 2.508-1.439s-1.123-1.44-2.508-1.44-2.508.645-2.508 1.44c0 .795 1.123 1.439 2.508 1.439Z"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M189.405 115.562c.968 0 1.753-.45 1.753-1.006 0-.555-.785-1.005-1.753-1.005-.969 0-1.754.45-1.754 1.005 0 .556.785 1.006 1.754 1.006Z"
        fill="#12173D"
        stroke="#1C1C1C"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m206.847 117.756 3.57 2.081a.947.947 0 0 1 .032 1.621l-9.598 5.871a2.083 2.083 0 0 1-2.144.019l-3.777-2.206a.946.946 0 0 1 .012-1.634l10.013-5.758a1.905 1.905 0 0 1 1.886 0l.006.006Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.805 111.714c.885 0 1.603-.411 1.603-.917 0-.507-.718-.918-1.603-.918s-1.603.411-1.603.918c0 .506.718.917 1.603.917Z"
        fill="#12173D"
        stroke="#1C1C1C"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m199.575 125.77-2.476-1.408a.485.485 0 0 1-.006-.843l7.586-4.45a1.593 1.593 0 0 1 1.597-.006l2.231 1.282a.711.711 0 0 1 0 1.238l-7.241 4.092c-.32.189-.628.29-.924.302a1.319 1.319 0 0 1-.754-.207h-.013Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m201.015 124.147 3.985-.59-3.74 2.118a2.206 2.206 0 0 1-.924.302v-1.044c0-.396.289-.729.685-.786h-.006Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m197.08 122.074 3.91-.861 4.004 2.344-3.985.591c-.151.013-.308.088-.472.233l-3.564-1.836c-.207-.125-.132-.44.107-.471Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.854 123.972v-1.665s-.057.157.32.358l3.363 1.722c-.132.138-.201.321-.207.553v1.044a1.336 1.336 0 0 1-.755-.208l-2.476-1.408a.531.531 0 0 1-.245-.396Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M133.588 38.456a1.406 1.406 0 0 0-.377-.132c-.717-.126-1.408.446-1.559 1.276-.132.76.239 1.47.849 1.678l2.558 1.27 1.15-2.76-2.621-1.332Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M136.895 41.392c.153-.83-.301-1.61-1.014-1.741-.714-.132-1.416.433-1.57 1.263-.153.83.301 1.609 1.015 1.74.713.133 1.416-.433 1.569-1.263Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M136.425 41.303c.098-.53-.191-1.026-.645-1.11-.454-.084-.901.277-.999.806-.097.53.191 1.026.645 1.11.454.084.902-.277.999-.806Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M131.602 79.266c2.236 0 4.048-1.039 4.048-2.32 0-1.28-1.812-2.319-4.048-2.319-2.236 0-4.048 1.038-4.048 2.32 0 1.28 1.812 2.319 4.048 2.319Z"
        fill="#101841"
      />
      <path
        d="M128.22 69.58v6.99c0 .49.327.98.974 1.351 1.302.748 3.414.748 4.715 0 .641-.37.968-.848.974-1.332V69.58h-6.669.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M131.558 71.492c1.844 0 3.338-.856 3.338-1.911 0-1.056-1.494-1.911-3.338-1.911-1.843 0-3.338.855-3.338 1.91 0 1.056 1.495 1.912 3.338 1.912Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M129.836 65.867v3.608c0 .252.17.503.503.698.672.383 1.76.383 2.432 0 .333-.189.497-.44.503-.685v-3.614h-3.438v-.007Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M131.558 66.853c.951 0 1.722-.442 1.722-.987 0-.545-.771-.987-1.722-.987s-1.722.442-1.722.987c0 .545.771.987 1.722.987Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M132.343 50.303c2.207-1.144 4.928-.145 5.859 2.15l3.545 8.787a.598.598 0 0 0 .848.295.599.599 0 0 0 .302-.509v-13.08c0-.867-.459-1.672-1.207-2.112l-6.33-3.784a.925.925 0 0 1-.44-.95.93.93 0 0 1 1.377-.64l6.078 3.495a4.546 4.546 0 0 1 2.307 3.947v13.093a2.24 2.24 0 0 1-1.119 1.936c-1.175.685-2.696.189-3.231-1.056l-3.878-9.058a2.053 2.053 0 0 0-2.847-1 2.027 2.027 0 0 0-1.081 1.792v11.516a.9.9 0 0 1-.906.898.904.904 0 0 1-.905-.898V53.704c0-1.773.434-2.76 1.635-3.4h-.007Z"
        fill="#354070"
      />
      <path
        d="M143.18 86.31c2.236 0 4.048-1.038 4.048-2.319 0-1.28-1.812-2.32-4.048-2.32-2.235 0-4.048 1.04-4.048 2.32 0 1.281 1.813 2.32 4.048 2.32Z"
        fill="#101841"
      />
      <path
        d="M139.836 76.615v6.99c0 .49.327.98.975 1.351 1.301.748 3.413.748 4.714 0 .641-.37.968-.848.974-1.332v-7.009h-6.669.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M143.168 78.525c1.843 0 3.337-.856 3.337-1.911 0-1.055-1.494-1.91-3.337-1.91-1.844 0-3.338.855-3.338 1.91s1.494 1.91 3.338 1.91Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M141.452 72.9v3.608c0 .252.17.503.503.698.672.383 1.76.383 2.432 0 .333-.189.497-.44.503-.685v-3.614h-3.438V72.9Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M143.168 73.886c.951 0 1.722-.442 1.722-.987 0-.545-.771-.987-1.722-.987-.952 0-1.723.442-1.723.987 0 .545.771.987 1.723.987Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="m150.572 57.65 2.358 10.17c.603 2.596 3.551 3.885 5.889 2.571l19.813-11.163a3.85 3.85 0 0 1 3.802.012l35.452 20.41a1.526 1.526 0 0 1 .012 2.646l-9.592 5.752 1.685 1.514 8.724-5.135c2.533-1.527 2.483-5.186-.081-6.65l-35.112-20.183a6.388 6.388 0 0 0-6.305-.007l-19.542 11.05c-1.062.598-2.407.026-2.69-1.156l-2.489-10.265c-.566-2.344-2.684-3.997-5.11-3.997-2.904 0-5.255 2.338-5.255 5.217v13.797c0 .547.402 1.037.955 1.087a1.056 1.056 0 0 0 1.163-1.043V58.379c0-1.76 1.44-3.193 3.218-3.193a3.217 3.217 0 0 1 3.131 2.458l-.026.006Z"
        fill="#101841"
      />
      <path
        d="m212.429 91.662-.044 8.404a.934.934 0 0 1-.346.729l.019.025-9.623 5.984-11.415-6.927-.647-10.308 9.221-5.708.025.02a.99.99 0 0 1 1.157-.127l10.629 6.116a2.075 2.075 0 0 1 1.037 1.792h-.013Z"
        fill="#0085FF"
        stroke="#1C1C1C"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m201.43 106.804-10.78-6.21a1.731 1.731 0 0 1-.868-1.496l-.012-8.574c0-.754.823-1.225 1.483-.848l10.629 6.116a2.075 2.075 0 0 1 1.037 1.791l-.044 8.404c0 .729-.798 1.175-1.433.811l-.012.006Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m200.203 104.755-8.636-5.022a1.215 1.215 0 0 1-.61-1.05l-.012-6.028a.694.694 0 0 1 1.043-.597l8.53 4.96c.452.257.729.741.729 1.263l-.032 5.908c0 .51-.559.83-1.005.572l-.007-.006Z"
        fill="#E6E7E9"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.798 96.31c0 .508-.264.936-.628 1.08l-2.929 1.616a1.1 1.1 0 0 1-1.534-.51 1.086 1.086 0 0 1 .478-1.389l3.3-1.791.019-.013a.742.742 0 0 1 .408-.125c.497 0 .893.509.893 1.131h-.007ZM200.417 100.145c0 .509-.264.937-.629 1.081l-2.929 1.616a1.098 1.098 0 0 1-1.533-.51 1.085 1.085 0 0 1 .477-1.389l3.3-1.791.019-.013a.745.745 0 0 1 .409-.125c.496 0 .892.509.892 1.131h-.006Z"
        fill="#fff"
        stroke="#1C1C1C"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m148.491 55.37-1.049-.176c-1.785 0-3.225 1.426-3.225 3.193V72.29c0 .61-.528 1.1-1.156 1.038a.938.938 0 0 1-.377-.114 1.114 1.114 0 0 1-.579-.974V58.443c0-1.44.591-2.747 1.546-3.69a5.295 5.295 0 0 1 5.658-1.15c-.799.478-.887 1.232-.818 1.773v-.006Z"
        fill="#101841"
      />
      <path
        d="m148.491 55.37-1.049-.176c-1.785 0-3.225 1.426-3.225 3.193V72.29c0 .61-.528 1.1-1.156 1.038a.938.938 0 0 1-.377-.114 1.114 1.114 0 0 1-.579-.974V58.443c0-1.44.591-2.747 1.546-3.69a5.295 5.295 0 0 1 5.658-1.15c-.799.478-.887 1.232-.818 1.773v-.006Z"
        fill="#101841"
      />
      <path
        d="m127.56 31.256-.038-1.704-.038-1.433-.238-9.56"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.401 4.802 96.434 37.92c0 1.226.66 2.363 1.729 2.98l28.26 16.241c1.358.78 3.061-.195 3.061-1.753l1.967-32.44c0-1.226-.66-2.364-1.728-2.98L100.847 3.406c-1.088-.622-2.445.157-2.445 1.402v-.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeMiterlimit="10"
      />
      <path
        d="M191.655 129.469a3.065 3.065 0 0 0-1.251-1.364l-17.04-9.862a8.167 8.167 0 0 0-8.077 0 2.8 2.8 0 0 0-1.427 2.646v.025a2.862 2.862 0 0 1-.264-1.012v-.201a2.805 2.805 0 0 1 1.427-2.646 8.115 8.115 0 0 1 4.041-1.069c1.396 0 2.785.352 4.036 1.069l17.034 9.862c.974.56 1.527 1.571 1.515 2.558l.006-.006Z"
        fill="#12173D"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M191.655 129.469c0 .132-.012.264-.038.396-.125.761-.66 1.647-1.408 2.106a8.073 8.073 0 0 1-4.217 1.181 7.942 7.942 0 0 1-4.036-1.074l-16.939-9.919a2.809 2.809 0 0 1-1.163-1.251v-.025a2.805 2.805 0 0 1 1.427-2.646 8.112 8.112 0 0 1 4.041-1.069c1.396 0 2.785.352 4.036 1.069l17.04 9.862a3.002 3.002 0 0 1 1.251 1.364l.006.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M191.655 129.469c0 .132-.012.264-.038.396-.125.761-.66 1.647-1.408 2.106a8.073 8.073 0 0 1-4.217 1.181 7.942 7.942 0 0 1-4.036-1.074l-16.939-9.919a2.809 2.809 0 0 1-1.163-1.251v-.025a2.805 2.805 0 0 1 1.427-2.646 8.112 8.112 0 0 1 4.041-1.069c1.396 0 2.785.352 4.036 1.069l17.04 9.862a3.002 3.002 0 0 1 1.251 1.364l.006.006Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".51"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.694 118.885v3.778c0 1.314-2.439 2.376-5.481 2.407h-.151c-.169 0-.339 0-.509-.012a11.938 11.938 0 0 1-.968-.076c-2.388-.276-4.155-1.213-4.155-2.325v-3.778h11.264v.006Z"
        fill="#0085FF"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M178.694 118.883v3.777c0 1.314-2.439 2.376-5.481 2.408v-6.185h5.481ZM172.553 118.883v6.179a11.902 11.902 0 0 1-.968-.076v-6.103h.968Z"
        fill="#0D6ECE"
      />
      <path
        d="M178.694 118.885v3.778c0 1.314-2.439 2.376-5.481 2.407h-.151c-.169 0-.339 0-.509-.012a11.938 11.938 0 0 1-.968-.076c-2.388-.276-4.155-1.213-4.155-2.325v-3.778h11.264v.006Z"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.062 121.298c3.111 0 5.632-1.081 5.632-2.414 0-1.333-2.521-2.413-5.632-2.413-3.11 0-5.632 1.08-5.632 2.413 0 1.333 2.522 2.414 5.632 2.414Z"
        fill="#fff"
        stroke="#101841"
        strokeWidth=".32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M106.71 18.423c-.389-.227-.785-.277-1.081-.107l-1.841 1.03c.301-.17.427.07.817.29.389.22.779.616 1.081 1.131l4.922 8.48 2.382-.962-5.198-8.731c-.296-.51-.686-.905-1.082-1.131ZM114.782 31.271l-2.119 1.22 4.903 8.435c.302.516.446 1.05.446 1.496 0 .447-.094.723-.396.893l2.062-1.132c.302-.17.453-.534.453-.98 0-.447-.145-.98-.447-1.496l-4.902-8.436ZM116.856 26.304c.358.207.716.566.993 1.037s.409.955.409 1.364c0 .409-.12.704-.396.861l1.91-1.081c.277-.157.415-.49.415-.899 0-.409-.132-.899-.408-1.364-.271-.471-.629-.83-.993-1.037-.359-.207-.717-.258-.994-.1l-1.936 1.112c.277-.157.635-.107.994.1l.006.007Z"
        fill="#12173D"
      />
      <path
        d="m112.764 32.497 5.173-2.923c.277-.157.415-.49.421-.905.006-.415-.138-.905-.415-1.383-.276-.478-.641-.842-.999-1.05-.365-.207-.729-.257-1.006-.1l-5.129 2.897-4.959-8.523c-.277-.478-.641-.842-1-1.05-.358-.207-.729-.257-1.005-.1-.277.157-.415.49-.422.905 0 .415.139.905.415 1.383l4.96 8.523-5.117 2.898c-.276.157-.415.49-.421.905 0 .415.138.905.415 1.383.276.477.641.842.999 1.05.359.207.729.257 1.006.1l5.073-2.866 4.959 8.53c.276.477.635.842.999 1.05.365.207.729.257 1.006.1s.415-.49.421-.905c.006-.415-.138-.906-.415-1.383l-4.959-8.53v-.006Z"
        fill="#E92C2C"
      />
    </svg>
  );
};

export default ComputerChatScreenIcon;
